import ProcessUtils from 'utils/ProcessUtils';
import AbstractLocalStorageComponent from 'components/core/AbstractLocalStorageComponent';

/**
 * Forms should extend this class to inherit general methods for field updates and validation.
 */
export default class AbstractForm extends AbstractLocalStorageComponent {

    onFieldUpdated = (fieldPath, value) => {
        ProcessUtils.updateField(this.props.process, fieldPath, value);
    };
}



// WEBPACK FOOTER //
// ./src/components/page/process/AbstractForm.js